<template>
  <div
    class="info post--info post-info-container"
    :class="{ fromProfilePostCard: fromProfilePostCard }"
  >
    <div class="leftAlign">
      <IconComponent
        v-if="post.type == 'text'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Text_Three.svg"
      />
      <IconComponent
        v-if="post.type == 'analysis'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Analysis_three.svg"
      />
      <IconComponent
        v-if="post.type == 'profile'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Profile_Three.svg"
      />
      <IconComponent
        v-if="post.type == 'media'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Media.svg"
      />
      <IconComponent
        v-if="post.type == 'charts'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Charts.svg"
      />
      <IconComponent
        v-if="post.type == 'watchList'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Watchlist.svg"
      />
      <IconComponent
        v-if="post.type == 'portfolio'"
        path="/create_post"
        className="postInfo_icon"
        style="margin-top: -5px"
        icon="Create Post_Trades_two.svg"
      />
      <IconComponent
        v-if="post.type == 'paper'"
        path="/create_post"
        className="postInfo_icon"
        icon="Create Post_Watchlist.svg"
      />
      <IconComponent
        v-if="post.type == 'repost'"
        path="/post_card"
        className="postInfo_icon"
        icon="icons_retweet.svg"
      />
      <IconComponent
        v-if="post.type == 'club'"
        path="/post_card"
        className="postInfo_icon f-s"
        icon="icons_club.svg"
      />
      <p class="lightText" style="font-size: 12px">
        {{ $t(`common.common.${post.type.toUpperCase()}`) }}
      </p>
    </div>
    <template v-if="!fromOutside">
      <div class="rightAlign">
        <a class="icon_more" v-if="isSavedPost">
          <template v-if="isMine">
            <PopoverMenu
              trigger="hover"
              :menuItems="menuItems"
              placement="bottom-end"
            >
              <template #reference>
                <IconComponent
                  path="/post_card"
                  icon="icons_more.svg"
                  class="postInfo_icon"
                />
              </template>
            </PopoverMenu>
          </template>
        </a>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import PostsModel from "../../models/posts.model";
import storageService from "@/services/storage.service";
import { usePosts } from "../../composables/posts.composables";
import { computed, defineComponent, onMounted, ref } from "vue";
import DeletePostComponent from "./DeletePostComponent.vue";
import { openModal, popModal, promptModal } from "jenesius-vue-modal";
import IconComponent from "@/components/IconComponent.vue";
import httpService from "@/services/http.service";
import utilService from "@/services/util.service";
import { TYPE } from "vue-toastification";
import { useSavedAssets } from "../../composables/savedassets.composable";
import { useI18n } from "vue-i18n";
export default defineComponent({
  props: ["post", "isSavedPost", "fromProfilePostCard", "fromOutside"],
  components: {
    IconComponent,
  },
  setup(props) {
    const { deletePost } = usePosts();
    const post = ref<PostsModel>(props.post);
    const isMine = ref<boolean>(false);
    const { checkSavedPost, getSavedAssets } = useSavedAssets();

    const getDate = computed(() => {
      return new Date(parseInt(props.post._id));
    });
    const dismiss = () => popModal();

    const isAlreadySaved = ref<boolean>(false);

    const isSavedPost = ref<Boolean>(props.isSavedPost ?? true);

    const { t } = useI18n();

    const menuItems = ref([
      {
        text: t('profileDetails.labels.DeletePost'),
        icon: 'delete-icon.svg',
        action: () => showDeletePostModal(new Event('click')),
        condition: true
      }
    ]);

    onMounted(() => {
      var user = storageService.getUser();
      isMine.value = post.value.userId == user._id;
      isAlreadySaved.value = checkSavedPost(post.value._id!);
    });

    const showDeletePostModal = async (event: any) => {
      event.stopPropagation();
      var modal: any = await promptModal(DeletePostComponent, {
        postId: post.value._id,
      });
      if (modal.close) {
        dismiss();
      }
    };

    const EditPostModal = (event: any) => {
      event.stopPropagation();
    };

    const handleSavePost = (post: PostsModel) => {
      let data = {
        assetId: post._id,
        assetType: "post",
        assetData: { ...post },
      };

      httpService.handleDataForAssets(data).then(async (response: any) => {
        if (response.data.isSuccess) {
          await getSavedAssets();
          isAlreadySaved.value = checkSavedPost(post._id!);
          utilService.showToast("Successfully saved in assets", TYPE.SUCCESS);
        } else {
          utilService.showToast("Assets Already Exists", TYPE.ERROR);
        }
      });
    };

    const handleDeleteAssetsApi = (post: any) => {
      httpService.deleteDataFromAssets(post._id).then(async (response) => {
        if (response.data.isSuccess) {
          await getSavedAssets();
          isAlreadySaved.value = checkSavedPost(post._id!);
          utilService.showToast(
            "Successfully delete from assets",
            TYPE.SUCCESS
          );
        }
      });
    };

    return {
      post,
      isMine,
      isAlreadySaved,
      showDeletePostModal,
      EditPostModal,
      handleSavePost,
      handleDeleteAssetsApi,
      isSavedPost,
      getDate,
      menuItems,
    };
  },
});
</script>

<style lang="scss" scoped>
.dropdown-box {
  overflow: hidden;
  background-color: var(--base-darkest);
  border-radius: 8px;
  line-height: 1.4;
  font-size: var(--el-popover-font-size);
  .item {
    font-size: var(--font-xs);
    i {
      font-size: var(--font-xs) !important;
      margin-inline-end: 10px;
      opacity: 0.8;
    }
  }
  // box-shadow: var(--el-box-shadow-light);
  // word-break: break-all;
  // box-sizing: border-box;
  // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12)
}

.popover_content.more_options {
  top: 0;
}

.post-info-container {
  border-radius: 0px !important;
  padding-block: 0px !important;
  .postInfo_icon {
    max-width: 20px;
    color: var(--base-text);
  }
}
.fromProfilePostCard {
  z-index: 9 !important;
}
.card--post .info .leftAlign .postInfo_icon {
  margin-top: 0px;
}
</style>